import { Button } from 'primereact/button';
import { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Toast, ToastMessage } from "primereact/toast";
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';

interface SearchPanelProps {
  onSearch: (filters: any) => void;
  setLoading: (loading: boolean) => void;
}

const InternalComplaintSearch: React.FC<SearchPanelProps> = ({
  onSearch,
  setLoading,
}) => {
  const { t } = useTranslation();
  const toast = useRef<Toast>(null);
  const [startDate, setStartDate] = useState<any>();
  const [endDate, setEndDate] = useState<any>();
  const [searchKeyword, setSearchKeyword] = useState<string>('');

  const handleSearch = () => {   
    const filters = {
      startDate: startDate != null ? 
        new Date(startDate.setHours(0, 0, 0, 0)) : null,
      endDate: endDate != null ? 
        new Date(endDate.setHours(23, 59, 59, 999)) : null,
      searchKeyword: searchKeyword
    };
    onSearch(filters);
  };

  const resetSearchFields = () => {
    setStartDate(null);
    setEndDate(null);
    setSearchKeyword('');
    onSearch({
      startDate: null,
      endDate: null,
      searchKeyword: ''
    });
  };

  const showMessage = (label: string, message: string, severity: ToastMessage['severity']) => {
    toast.current?.show({ severity: severity, summary: label, detail: message, life: 3000 });
  };

  return (
    <div className="col-12" style={{ width: "100%", padding: "0px", marginBottom: "0.5rem" }}>
      <Toast ref={toast} />
      <div className="card border-noround p-2" style={{ minHeight: '3.5rem' }}>
        <div className="p-fluid grid p-2">
          <div className="col-12 md:col-3">
            <span>
              <InputText
                id="searchKeyword"
                value={searchKeyword}
                onChange={(e) => setSearchKeyword(e.target.value)}
                style={{ width: '100%' }}
                placeholder='Search by keyword'
              />
              <label htmlFor="searchKeyword"></label>
            </span>
          </div>

          <div className="col-12 sm:col-6 lg:col-3 font-bold text-white border-round"
               style={{ display: 'flex', justifyContent: 'space-between', padding: '5px' }}>
            <Calendar
              value={startDate}  
              onChange={(e) => setStartDate(e.value)}
              dateFormat="dd/mm/yy"
              style={{ width: "50%", marginRight:"10px" }}
              placeholder="Start date 🗓️"
              showButtonBar
            />
            <Calendar
              value={endDate}  
              onChange={(e) => setEndDate(e.value)}
              dateFormat="dd/mm/yy"
              style={{ width: "50%"}}
              placeholder="End date 🗓️"
              showButtonBar
            />
          </div>

          <div className="col-12 md:col-4 flex align-items-center gap-3 ">
            <Button
              className="text-black border-round"
              style={{ width: "30%" }}
              onClick={handleSearch}
              severity="success"
            >
              Filter
            </Button>

            <Button
              className="text-black border-round"
              style={{ width: "30%" }}
              onClick={resetSearchFields}
              severity="secondary"
              text
              raised
            >
              Reset
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InternalComplaintSearch;